import React, { useState } from 'react'
import './formInput.css'
import { FormGroup, InputGroup, Intent, NumericInput } from '@blueprintjs/core'
import Cleave from 'cleave.js/react'
import DOMPurify from 'dompurify'
const BPFormInput = React.memo(
  ({
    label,
    type,
    info,
    id,
    required,
    placeholder,
    error,
    value,
    onChange,
    prependIcon,
    readOnly,
    onBlur,
    name,
    rows,
    min,
    maxLength,
    className,
    rightElement,
    masked,
    autoComplete,
    disabled,
    autoFocus,
    pattern,
    inputRef
  }) => {
    const [focus, setFocus] = useState(false)

    const handleOnChange = (event) => {
      // console.log(DOMPurify.sanitize(event.target.value))
      onChange && onChange(DOMPurify.sanitize(event.target.value))
    }

    const onNumeralChange = (event) => {
      // console.log(DOMPurify.sanitize(event.target.rawValue))
      onChange && onChange(DOMPurify.sanitize(event.target.rawValue))
    }
    const toggleFocus = () => {
      setFocus(!focus)
    }
    const handleOnBlur = (event) => {
      toggleFocus()
      onBlur && onBlur(event)
    }

    const handleNumericInputChange = (valueAsNumber, valueAsString) => {
      onChange && onChange(valueAsString)
    }
    /** ***VAR OLAN FORM_INPUT *****/
    //   const inputOrTextArea = rows ? (<textarea maxLength={maxLength || 2000} className={`form-control ${error ? 'is-invalid' : ''}`} rows={rows} onChange={handleOnChange} name={name} onFocus={toggleFocus} onBlur={handleOnBlur} value={value} id={id} placeholder={placeholder} required={required} readOnly={readOnly} />)
    //     : (<input min={type === 'number' ? min : ''} onChange={handleOnChange} name={name} onFocus={toggleFocus} onBlur={handleOnBlur} value={value} type={type} id={id} className={`form-control ${size ? 'form-control-' + size : ''}  ${error ? 'is-invalid' : ''}`} placeholder={placeholder} required={required} readOnly={readOnly} />)

    //   return (

    //     <div className={`form-group  ${focus ? 'has-length' : ''} mb-2`}>
    //       {label && <label className='form-label' htmlFor={id}>{label} {required && <span className='text-danger'>*</span>}</label>}
    //       <div className='input-group'>
    //         {prependIcon &&
    //           <div className='input-group-prepend'>
    //             <span className='input-group-text'>
    //               <i className={`fal ${prependIcon}`} />
    //             </span>
    //           </div>}
    //         {inputOrTextArea}
    //         {appendIcon &&
    //           <div className='input-group-append'>
    //             <span className='input-group-text'>
    //               <i className={`fal ${appendIcon}`} />
    //             </span>
    //           </div>}
    //       </div>
    //       <div className='invalid-feedback' style={{ display: 'block' }}>{error}</div>
    //       <div className='help-block'>{info}</div>
    //     </div>
    //   )
    // }
    /** ***VAR OLAN FORM_INPUT *****/
    const inputOrTextArea = rows ? (
      <textarea
        maxLength={maxLength || 2000}
        className={`form-control ${error ? 'is-invalid' : ''}`}
        rows={rows}
        onChange={handleOnChange}
        name={name}
        onFocus={toggleFocus}
        onBlur={handleOnBlur}
        value={value}
        id={id}
        placeholder={placeholder}
        required={required}
        readOnly={readOnly}
        autoFocus={autoFocus}
        disabled={disabled}
        ref={inputRef}
      />
    ) : type === 'number' ? (
      masked ? (
        <div className='bp3-control-group bp3-fill bp3-numeric-input'>
          <div className={`bp3-input-group ${error ? 'bp3-intent-danger' : ''}`}>
            <Cleave
              id={id}
              name={name}
              className='bp3-input'
              placeholder={`${placeholder || 'Enter number'}`}
              min={min}
              value={value}
              required={required}
              readOnly={readOnly}
              options={{ numeral: true, numeralThousandsGroupStyle: 'thousand' }}
              onChange={onNumeralChange}
              onBlur={handleOnBlur}
              onFocus={toggleFocus}
              autoFocus={autoFocus}
              disabled={disabled}
              ref={inputRef}
            />
          </div>
        </div>
      ) : (
        <NumericInput
          min={min}
          onValueChange={handleNumericInputChange}
          name={name}
          intent={error ? Intent.DANGER : Intent.NONE}
          value={value}
          id={id}
          placeholder={placeholder}
          required={required}
          readOnly={readOnly}
          fill
          buttonPosition='NONE'
          leftIcon={prependIcon}
          onBlur={handleOnBlur}
          allowNumericCharactersOnly
          rightElement={rightElement}
          autoFocus={autoFocus}
          disabled={disabled}
          ref={inputRef}
        />
      )
    ) : (
      <InputGroup
        id={id}
        name={name}
        placeholder={placeholder}
        className={className}
        onFocus={toggleFocus}
        onChange={handleOnChange}
        value={value}
        intent={error ? Intent.DANGER : Intent.NONE}
        required={required}
        readOnly={readOnly}
        type={type || 'text'}
        pattern={pattern}
        leftIcon={prependIcon}
        onBlur={handleOnBlur}
        autoComplete={autoComplete}
        rightElement={rightElement}
        disabled={disabled}
        autoFocus={autoFocus}
        ref={inputRef}
      />
    )

    return (
      <FormGroup
        className={`bpFormGroup ${error ? 'bpFormError' : info ? 'bpFormInfo' : ''}`}
        label={label}
        labelFor={id}
        labelInfo={required && '*'}
        helperText={`${error || info || ''}`}
      >
        {inputOrTextArea}
      </FormGroup>
    )
  },
)

export default BPFormInput
// rows props for text area input
/* USAGE SAMPLE
    <FormInput
      label='Full Name'
      name='fullName'
      type='text'
      size='sm'
      value={formik.values.fullName}
      onBlur={formik.handleBlur}
      onChange={(val) => changeFormikField('fullName', val)}
      error={formik.errors.fullName && formik.touched.fullName && formik.errors.fullName}
    />
 */
/*
     <div className='row'>
          <div className='col-lg-6'>
            <div className='form-group row'>
              <label htmlFor='inputEmail3' className='col-form-label col-sm-2 text-sm-left form-label'>Email</label>
              <div className='col-sm-10'>
                <FormInput
                  name='Email'
                  placeholder='Email'
                  type='text'
                  size='sm'
                />
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='form-group row'>
              <label htmlFor='inputEmail3' className='col-form-label col-sm-2 text-sm-left form-label'>Email</label>
              <div className='col-sm-10'>
                <FormInput
                  name='Email'
                  placeholder='Email'
                  type='text'
                  size='sm'
                />
              </div>
            </div>
          </div>
        </div>
*/
